import Link from "next/link";
import { BsList, BsFillXCircleFill } from "react-icons/bs";
import { useLanguage } from "@/providers/LanguageContext";
import styles from "../Header.module.css";

interface MobileNavigationProps {
  isMenuOpen: boolean;
  isAuthenticated: boolean;
  onToggleMenu: () => void;
  onContactClick: () => void;
  onMenuItemClick: () => void;
}

export function MobileNavigation({
  isMenuOpen,
  isAuthenticated,
  onToggleMenu,
  onContactClick,
  onMenuItemClick
}: MobileNavigationProps) {
  const { language, setLanguage } = useLanguage();

  const handleContactClick = () => {
    onContactClick();
    onMenuItemClick();
  };

  return (
    <>
      {/* Mobile menu toggle */}
      <div className={styles.mobileMenuToggle}>
        <button onClick={onToggleMenu} className={styles.mobileMenuButton}>
          {isMenuOpen ? <BsFillXCircleFill /> : <BsList />}
        </button>
      </div>

      {/* Mobile Navigation Overlay */}
      {isMenuOpen && (
        <>
          {/* Backdrop */}
          <div className={styles.mobileMenuBackdrop} onClick={onToggleMenu} />

          {/* Drawer */}
          <div className={styles.mobileMenuDrawer}>
            <nav className={styles.mobileNav}>
              <Link
                href="/courses"
                onClick={onMenuItemClick}
                className={styles.mobileNavLink}
              >
                {language === 'es' ? 'Cursos' : 'Courses'}
              </Link>
              <Link
                href="/articles"
                onClick={onMenuItemClick}
                className={styles.mobileNavLink}
              >
                {language === 'es' ? 'Artículos' : 'Articles'}
              </Link>
              <Link
                href="#section-contact"
                onClick={handleContactClick}
                className={styles.mobileContactButton}
              >
                {language === 'es' ? 'Contacto' : 'Contact'}
              </Link>

              {/* Mobile Language Toggle */}
              <div className={styles.mobileLanguageToggle}>
                <button
                  className={`${styles.mobileLanguageButton} ${language === 'en' ? styles.mobileLanguageButtonActive : ''}`}
                  onClick={() => setLanguage('en')}
                >
                  🇺🇸 English
                </button>
                <button
                  className={`${styles.mobileLanguageButton} ${language === 'es' ? styles.mobileLanguageButtonActive : ''}`}
                  onClick={() => setLanguage('es')}
                >
                  🇵🇪 Español
                </button>
              </div>

              {/* Auth Link */}
              <Link
                href={isAuthenticated ? "/dashboard" : "/login"}
                onClick={onMenuItemClick}
                className={styles.mobileAuthLink}
              >
                {isAuthenticated
                  ? (language === 'es' ? 'Panel' : 'Dashboard')
                  : (language === 'es' ? 'Iniciar Sesión' : 'Login')
                }
              </Link>
            </nav>
          </div>
        </>
      )}
    </>
  );
}